import React from 'react';
import { useState, useEffect } from "react";
import StripeCheckout from 'react-stripe-checkout';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import axios from "axios";
import dayjs from 'dayjs'

const config = require("../../../constants/constants.js")

const { strCurrency, strEuroCurrency } = require('../../../utils/currencyUtils.js')
const { strDateITAfromDayJs, strDateUSAfromDayJs, strDateITAfromStrUSA, strDateUSAfromStrITA } = require('../../../utils/dateUtils.js')

const PaymentCard = ({ datiGiornoAgenda, indexResource, indexHour, productName, price, productBookingPrice, productImage, productProduct, productCategory, envVariable, setShowAlertPagaPrenotazione, setShowAlertGraziePagamento, setPaymentExecuted }) => {

    console.log(' [PaymentCard] indexResource=', Number(indexResource));
    console.log(' [PaymentCard] indexHour=', Number(indexHour));
    console.log(' [PaymentCard] datiGiornoAgenda.day=', datiGiornoAgenda.day);
    console.log(' [PaymentCard] datiGiornoAgenda=', datiGiornoAgenda);
    console.log(' [PaymentCard] envVariable=', envVariable);

    const product = {
        id: 2,
        name: productName,
        image: productImage,
        price: productBookingPrice,
    }

    console.log(' [PaymentCard] productName=', productName);
    console.log(' [PaymentCard] price=', price);
    console.log(' [PaymentCard] productImage=', productImage);
    console.log(' [PaymentCard] productBookingPrice=', productBookingPrice);

    const createPaymentApiRequest = async (storePaymentForm) => {
        console.log(' [createPaymentApiRequest] storePaymentForm=', storePaymentForm);
        const { data } = await axios.post(`/api/payments`, { ...storePaymentForm });
        return data;
    };

    const createEmailPaymentApiRequest = async (emailPaymentForm) => {
        console.log(' [createEmailPaymentApiRequest] emailPaymentForm=', emailPaymentForm);
        const { data } = await axios.post(`/api/payments/email`, { ...emailPaymentForm });
        return data;
    };

    const makePayment = async (token) => {

        const body = {
            token,
            product
        }

        //console.log("??? che porta uso  =",'%'+envVariable.trim()+'%');
        //const URL_STRIPE = "http://localhost:"+envVariable.trim()+"/payment";      
        const URL_STRIPE = '/payment';
        //console.log("URL_STRIPE =>",URL_STRIPE);

        const response = await fetch(URL_STRIPE, {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        });

        console.log("`prodotto in acquisto : ", product);

        const data = await response.json();

        console.log('[PaymentCard] risposta al pagamento  data=', data)

        if (data.status === "succeeded") {
            console.log("esito acquisto = succeeded");

            // -INI---  creo nuovo payment su DB payments

            const storePaymentForm =
            {
                "idPayment": data?.id,
                "productId": "67694b7f28591244ddd0dbb6",
                "productPrice": price,
                "categoryDescription": productCategory,
                "productDescription": productProduct,
                "amount": productBookingPrice,
                "date": dayjs(new Date()).format('YYYY-MM-DD'),
                "hour": dayjs(new Date()).format('HH:mm:ss'),
                "client_ip": "",
                "email": data?.source.name,
                "type": data?.source.object,
                "card": {
                    "id": data?.source.id,
                    "object": data?.source.object,
                    "brand": data?.source.brand,
                    "country": data?.source.country,
                    "cvc_check": data?.source.cvc_check,
                    "funding": data?.source.funding,
                    "last4": data?.source.last4,
                    "name": data?.source.name
                }
            }

            console.log("createPaymentApiRequest=", storePaymentForm);

            createPaymentApiRequest(storePaymentForm);

            // -FIN---  creo nuovo payment su DB payments

            // ---INI---  send email riceduta pagamento


            const emailPaymentForm =
            {
                "application": applicativo,
                "ragioneSociale": ragioneSociale,
                "indirizzo": indirizzo,
                "cap": cap,
                "citta": citta,
                "appointmentDate": "",
                "appointmentHour": "",
                "idPayment": data?.id,
                "productId": "67694b7f28591244ddd0dbb6",
                "productPrice": price,
                "categoryDescription": productCategory,
                "productDescription": productProduct,
                "amount": productBookingPrice,
                "date": dayjs(new Date()).format('YYYY-MM-DD'),
                "hour": dayjs(new Date()).format('HH:mm:ss'),
                "client_ip": "",
                "email": data?.source.name,
                "type": data?.source.object,
                "card": {
                    "id": data?.source.id,
                    "object": data?.source.object,
                    "brand": data?.source.brand,
                    "country": data?.source.country,
                    "cvc_check": data?.source.cvc_check,
                    "funding": data?.source.funding,
                    "last4": data?.source.last4,
                    "name": data?.source.name
                },
                "hostTransmitter": "smtp.hostinger.com",
                "emailTransmitter": "support@mpmproject.it",
                "pswTransmitter": "Supp10mpm!",
                "emailToSend": data?.source.name
            }

            createEmailPaymentApiRequest(emailPaymentForm);

            // ---FIN---  send email riceduta pagamento

            setShowAlertPagaPrenotazione(false);
            setShowAlertGraziePagamento(true);
            setPaymentExecuted(storePaymentForm);

        }
        else {
            console.log("Pagamento fallito");
        }

        setShowAlertPagaPrenotazione(false);
        setShowAlertGraziePagamento(true);

        return data;
    }

    const [applicativo, setApplicativo] = useState("");                      
    const [ragioneSociale, setRagioneSociale] = useState("");                      
    const [indirizzo, setIndirizzo] = useState("");                      
    const [cap, setCap] = useState("");                      
    const [citta, setCitta] = useState("");                      
    const [email, setEmail] = useState("");                      
    const [telefonoCallFromSite, setTelefonoCallFromSite] = useState("");     
    const [linkWhatsapp, setLinkWhatsapp] = useState("");     
    const [linkFacebook, setLinkFacebook] = useState("");     
    const [linkInstagram, setLinkInstagram] = useState("");     
    const [linkTwitter, setLinkTwitter] = useState("");     
    const [linkLinkedin, setLinkLinkedin] = useState("");     
    const [urlSiteImageServer, setUrlSiteImageServer] = useState("");                      
    const [urlCustomerImageServer, setUrlCustomerImageServer] = useState("");                      
    
    const getConfigByProgressivoApiRequest = async (progressivoRagSoc) => {
        console.log("[getConfigByProgressivoApiRequest] leggo const con progressivo =",progressivoRagSoc);
        const url = `/api/configs/progressivo/`+progressivoRagSoc;
        const { data } = await axios.get(url);
        return data
    }

    useEffect(() => {
        getConfigByProgressivoApiRequest('0001').then((data) => { 
            console.log(`data =`, data);  
            setApplicativo(data?.applicativo);
            setRagioneSociale(data?.ragioneSociale);
            setIndirizzo(data?.indirizzo);
            setCap(data?.cap);
            setCitta(data?.citta);
            setEmail(data?.email);
            setTelefonoCallFromSite("tel:"+data?.telefonoCallFromSite)
            setLinkWhatsapp("https://wa.me/"+data?.linkWhatsapp);
            setLinkFacebook(data?.linkFacebook);
            setLinkInstagram(data?.linkInstagram);
            setLinkTwitter(data?.linkTwitter);
            setLinkLinkedin(data?.linkLinkedin);          
            setUrlSiteImageServer(data?.urlSiteImageServer);
            setUrlCustomerImageServer(data?.urlCustomerImageServer);
            console.log(`data?.applicativo =`, data?.applicativo);  
            console.log(`data?.linkWhatsapp =`, data?.linkWhatsapp);  
            console.log(`data?.linkFacebook =`, data?.linkFacebook);  
            console.log(`data?.linkInstagram =`, data?.linkInstagram);  
            console.log(`data?.linkTwitter =`, data?.linkTwitter);  
            console.log(`ragioneSociale =`, data?.ragioneSociale);  
            console.log(`urlCustomerImageServer =`, data?.urlCustomerImageServer);  
        })
        .catch((er) => {
            console.log(er);
        });  
    }, [ragioneSociale,setEmail,setUrlCustomerImageServer])
  

    return (

        <Box
            paddingLeft={{ xs: 0, md: 3 }}
        >

            <div className="card rounded-0 mt-2 mb-2 ms-2 me-2" style={{ width: "20rem" }}>

                <img src={productImage} className="card-img-top" alt={productName} width={300} />

                <div className="card-body">

                    <h5 className="card-title">{productName}</h5>

                    <Grid
                        size={{ xs: 12, md: 12 }}
                        paddingTop={{ xs: 0, md: 0 }}
                        paddingLeft={{ xs: 0, md: 0 }}
                        className="justify-content-right"
                        style={{
                            textAlign: "left"
                        }}>

                        <Typography sx={{ color: '#1136a0', fontSize: 18, paddingBottom: 1 }}>
                            totale {strEuroCurrency(price)}
                        </Typography>
                    </Grid>

                    <StripeCheckout
                        stripeKey={config.STRIPE_PUBLIC_KEY_FE}
                        token={makePayment}
                        name={productName}>
                        <button
                            className="btn btn-primary rounded-0 w-100"
                        >
                            Paga {strEuroCurrency(productBookingPrice)}
                        </button>
                    </StripeCheckout>

                </div>

            </div>
        </Box>
    )
}

export default PaymentCard
